import React, { Component } from "react";
import {
  Button,
  Grid,
  Header,
  Icon,
  Menu,
  Message,
  Modal,
  Loader,
  Segment
} from "semantic-ui-react";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import AList from "../../auto/AList";
import AForm from "../../auto/AForm";

const PAGE_RANGE = 10;
const INITIAL_STATE = {
  upsertModal: {
    open: false
  },
  removeModal: {
    open: false,
    loading: false,
    id: null,
    error: null
  },
  actas: {
    loading: false,
    records: [],
    error: null
  },
  acta: null
};

class CoopCargosView extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.ActaDistribucionCargosService = this.props.feathers.service(
      "/api/actas-cargos"
    );
    this.PersonaCargoService = this.props.feathers.service(
      "/api/persona-cargo"
    );
    this.CargoService = this.props.feathers.service("/api/cargos");
    this.PersonaService = this.props.feathers.service("/api/personas");
  }

  componentDidMount() {
    this.fetchActas();
  }

  fetchActas() {
    this.setState({
      actas: {
        ...this.state.actas,
        loading: true,
        error: null
      }
    });

    this.ActaDistribucionCargosService.find({
      query: {
        CooperativaId: this.props.cooperativa.id
      }
    })
      .then(response => {
        this.setState({
          actas: {
            ...this.state.actas,
            loading: false,
            records: response.records
          }
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          actas: {
            ...this.state.actas,
            loading: false,
            error: error
          }
        });
      });
  }

  toggleUpdateActaModal(acta) {
    this.setState({
      upsertModal: {
        ...this.state.upsertModal,
        open: !this.state.upsertModal.open
      },
      acta
    });
  }

  dismissUpsert() {
    this.setState({
      upsertModal: {
        ...this.state.upsertModal,
        open: false
      },
      acta: null
    });
  }

  doneSubmiting() {
    this.dismissUpsert();
    this.fetchActas();
  }

  openRemoveModal(id) {
    this.setState({
      removeModal: {
        ...this.state.removeModal,
        open: true,
        id: id
      }
    });
  }

  dismissRemove() {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  }

  removeRecord() {
    this.setState({
      removeModal: {
        ...this.state.removeModal,
        loading: true,
        error: null
      }
    });

    this.ActaDistribucionCargosService.remove(this.state.removeModal.id)
      .then(response => {
        this.setState(
          {
            removeModal: {
              ...this.state.removeModal,
              loading: false,
              open: false
            }
          },
          () => {
            this.dismissRemove();
            this.props.navigate(
              `/cooperativa/${this.props.cooperativa.id}/cargos`
            );
            this.fetchActas();
          }
        );
      })
      .catch(error => {
        this.setState({
          removeModal: {
            ...this.state.removeModal,
            loading: false,
            error: error
          }
        });
      });
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: path => {
        dispatch(push(path));
      }
    };
  }

  render() {
    let { upsertModal, removeModal, actas, acta } = this.state;
    let { cooperativa } = this.props;

    let cargoSelectConfig = {
      service: this.CargoService,
      mapFunction: (cargo, index) => {
        return {
          key: index,
          text: cargo.nombre,
          value: cargo.id
        };
      }
    };

    let personaSelectConfig = {
      service: this.PersonaService,
      params: {
        query: {
          InCooperativaId: cooperativa.id
        }
      },
      mapFunction: (persona, index) => {
        return {
          key: index,
          text: `${persona.apellido}, ${persona.nombre} (${persona.dni})`,
          value: persona.id
        };
      }
    };

    return (
      <Grid>
        <Grid.Column width={4}>
          <Header as="h4">
            <Button
              as={Icon}
              basic
              compact
              icon="plus"
              primary
              disabled={actas.loading}
              onClick={this.toggleUpdateActaModal.bind(this)}
            />
            <Header.Content>
              Actas
              <Header.Subheader>Distribucion de Cargos</Header.Subheader>
            </Header.Content>
          </Header>
          <Menu fluid vertical tabular>
            {actas.loading && <Loader active inline />}
            {actas.records.map((acta, index) => {
              let active = !!window.location.pathname.match(
                new RegExp(`^/cooperativa/[0-9]*/cargos/${acta.id}/?$`)
              );

              return (
                <Menu.Item
                  key={index}
                  active={active}
                  onClick={this.props.navigate.bind(
                    null,
                    `/cooperativa/${cooperativa.id}/cargos/${acta.id}`
                  )}>
                  {active && (
                    <Icon
                      name="trash"
                      color="red"
                      onClick={this.openRemoveModal.bind(this, acta.id)}
                    />
                  )}
                  {active ? <b>Nro {acta.nroActa}</b> : `Nro ${acta.nroActa}`}
                  <br />
                  {moment(acta.fecha).format("DD/MM/YYYY")}
                  {active && (
                    <Menu.Menu>
                      <Menu.Item
                        as={"button"}
                        name="editar"
                        onClick={this.toggleUpdateActaModal.bind(this, acta)}
                      />
                    </Menu.Menu>
                  )}
                </Menu.Item>
              );
            })}
          </Menu>
        </Grid.Column>

        <Grid.Column stretched width={12}>
          <Route
            exact
            path={`/cooperativa/:id/cargos/:acta`}
            render={({ match }) => {
              return (
                <AList
                  pageRange={PAGE_RANGE}
                  mapFunction={cargo => ({
                    id: cargo.id,
                    header: cargo.cargo.nombre,
                    description: `${cargo.persona.apellido}, ${
                      cargo.persona.nombre
                    } (${cargo.persona.dni}) hasta ${moment(
                      cargo.vigenteHasta
                    ).format("DD/MM/YYYY")}`
                  })}
                  service={this.PersonaCargoService}
                  options={{
                    serviceParams: {
                      acta: match.params.acta
                    }
                  }}
                  form={{
                    fields: [
                      [
                        "!Cargo",
                        "CargoId",
                        "asyncselect",
                        6,
                        cargoSelectConfig
                      ],
                      [
                        "!Persona",
                        "PersonaId",
                        "asyncselect",
                        10,
                        personaSelectConfig
                      ],
                      ["!Vigente Hasta", "vigenteHasta", "datetime", 6]
                    ],
                    service: this.PersonaCargoService,
                    options: {
                      serviceParams: {
                        ActaDistribucionCargosId: match.params.acta
                      }
                    }
                  }}
                />
              );
            }}
          />
        </Grid.Column>
        <Modal
          dimmer="blurring"
          size="small"
          open={upsertModal.open}
          onClose={this.dismissUpsert.bind(this)}>
          <Header icon="edit" content="Formulario de registro" />
          <Modal.Content>
            <AForm
              fields={[
                ["!Nro Acta", "nroActa", "input", 5],
                ["!Fecha", "fecha", "datetime", 5]
              ]}
              record={acta}
              service={this.ActaDistribucionCargosService}
              options={{
                serviceParams: {
                  CooperativaId: this.props.cooperativa.id
                }
              }}
              dismiss={this.dismissUpsert.bind(this)}
              doneSubmiting={this.doneSubmiting.bind(this)}
            />
          </Modal.Content>
        </Modal>
        <Modal
          dimmer="blurring"
          basic
          size="small"
          open={removeModal.open}
          onClose={this.dismissRemove.bind(this)}>
          <Header icon="trash" content="Eliminar registro" />
          <Modal.Content>
            <p>Seguro desea eliminar este registro?</p>
            {removeModal.error && (
              <Message negative>
                <Message.Header>
                  Error! {removeModal.error.message}
                </Message.Header>
                <p>{removeModal.error.name}</p>
              </Message>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="red"
              inverted
              disabled={removeModal.loading}
              onClick={this.dismissRemove.bind(this)}>
              <Icon name="remove" /> No
            </Button>
            <Button
              color="green"
              inverted
              disabled={removeModal.loading}
              onClick={this.removeRecord.bind(this)}>
              <Icon name="checkmark" />{" "}
              {removeModal.loading ? "Procesando..." : "Si"}
            </Button>
          </Modal.Actions>
        </Modal>
      </Grid>
    );
  }
}

export default connect(
  CoopCargosView.mapStateToProps,
  CoopCargosView.mapDispatchToProps
)(CoopCargosView);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopCargosView.js